import React, { useEffect, useState } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { CiBoxList } from 'react-icons/ci'
import { SetCookies } from '../../../_helpers/Cookies';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { IoChevronBackCircleOutline } from 'react-icons/io5';
import { useSubheader } from '../../../layout';
import axios from 'axios';
import { BASE_URL, NODE_API_URL } from '../../../../env_config';
import Cookies from "js-cookie"
import SearchGridComponent from './SearchGridComponent';
import SearchGridSkeleton from './SearchGridSkeleton';
import { toAbsoluteUrl } from '../../../_helpers';
import { Skeleton } from '@material-ui/lab';
import { UpdateAvailibility } from '../../popup/UpdateAvailibility';
import { ActiveShipping } from '../../popup/ActiveShipping';
import { RemoveStones } from '../../popup/RemoveStones';
import Sorting from '../../popup/Sorting';
import SVG from 'react-inlinesvg';
import { FaRegTrashAlt } from 'react-icons/fa';
import SearchDetail from '../detail/SearchDetail';
import { Logoutuser } from '../../controls/Logoutuser';

export default function SearchGrid({userinfo}) {
    const suhbeader = useSubheader();

    suhbeader.setTitle("Search Result");
    document.title ="Search Result | Diamonds on Call - Suppliers Center";
    const history = useHistory();
    const location = useLocation();
    const scrollRef = React.useRef(null);
    const [stoneData, setStoneData] = useState(location.state.searchresult);
    const [diamondselected,setDiamondSelected] = useState([])
    const [ stoneCount, setStoneCount ] = useState(0)
    const [ countloader, setCountLoader ] = useState(true)
    const [loader,setLoader] = useState(false)
    const [pagenumber,setPageNumber] = useState(location.state.page || 1)
    const [disablesorting,setDisableSorting] = useState(false)
    const [infiniteLoader,setInfiniteLoader] = useState(false)
    const [updatecount,setUpdateCount] = useState(false)
    const [shipStone,setShipStone] = useState([])
    const [updateAvailibilityPopup,setUpdateAvailibility] = useState(false)
    const [removeStonePopup,setRemoveStonePopup] = useState(false)
    const [shipPopup,setShipPopup] = useState(false)
    const [successMsg,setSuccessMsg] = useState(null)
    const isStockSearch = location.pathname.includes('stock-search');
    const [detailView,setDetailView] = useState([])
    const [totalDiamonds, setTotalDiamonds] = useState("0");
    const [totalDollarCarat, setTotalDollarCarat] = useState("0");
    const [totalPrice, setTotalPrice] = useState("0");
    const [totalCarat, setTotalCarat] = useState("0");

    const [sortobj,setSortObj] = useState({id:"",sortorder:""})
    const [selected, setSelected] = React.useState([]);
    const isSelected = (name) => selected.indexOf(name) !== -1;
    

    const handleClick = (event, name) => {
        console.log("name",name)
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
          newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
          newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
          newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
          newSelected = newSelected.concat(
            selected.slice(0, selectedIndex),
            selected.slice(selectedIndex + 1),
          );
        }
        console.log("newSelected",newSelected)
        let selectedData = [];
        for(let i = 0; i < newSelected.length; i++){
            let findData = stoneData.find(val => val?.stockID?.toString() === newSelected[i]?.toString())
            if(findData){
                selectedData.push(findData)
            }
        }
        setDiamondSelected(selectedData)
        setSelected(newSelected);
    };

    const ChangeView = () => {
        SetCookies("view","search-result")
        history.push({
            pathname: `/search-result`,
            state: {
                searchresult:location.state.searchresult,
                oldvalues:location.state.oldvalues,
                finalData:location.state.finalData
            }
        });
    };

    useEffect(() => {
        window.onbeforeunload = (event) => {
            sessionStorage.setItem("pageReloaded","1")
          };
      }, []);

    const ReloadStockPage = () => {
        setLoader(true)
        axios({
            method: "POST",
            url: `${NODE_API_URL}/SUPP/search-by-stock`,
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem("authToken")}`
            },
            data: location.state.finalData,
        })
            .then(function (res) {
                setStoneData(res.data.data)
                history.push({
                    pathname: "/search-result/stock-search",
                    state: {
                        searchresult: res.data.data,
                        oldvalues: null,
                        finalData: location.state.finalData
                    },
                    // state: decompress(res.data.ProductDetails),
                });
                setTimeout(() => {
                    setLoader(false)
                }, 1000)
            })
            .catch(error => {
                if(error?.response?.data?.message === "UnAuthorized!"){
                    Logoutuser();
                }
            })
    }

    const ReloadPage = () => {
        setLoader(true)
        const fancy = Cookies.get("fancy")?1:0
            window.Nat = location.state.oldvalues;
            let len = Object.keys(location.state.oldvalues).length;
            const temp = location.state.oldvalues;
            let data = "";
            for (let key in temp) {
                len--;
                let arr = temp[key];
                if (len) {
                    if (Array.isArray(arr)) {
                        let str = "";
                        str += "'" + arr.join("','") + "'";
                        data += `{"FilterName": "${key}","FilterValue":"${str}" }, `;
                    } else {
                        data += `{"FilterName": "${key}","FilterValue": "'${temp[key]}'"},`;
                    }
                } else {
                    if (Array.isArray(arr)) {
                        let str = "";
                        str += "'" + arr.join("','") + "'";
                        data += `{"FilterName": "${key}","FilterValue":"${str}" } `;
                    } else {
                        data += `{"FilterName": "${key}","FilterValue": "'${temp[key]}'"}`;
                    }
                }
            }
            let diamond_type = "N"
            if(userinfo.type !== "Natural"){
                diamond_type = "L"
            }
        const finalData = `{ "JsonData":  [${data}], "WLDiamondType": "${diamond_type}" ,"page":1,"fancy":"${fancy}" }`;
               
        axios({
            method: "POST",
            url: `${NODE_API_URL}/SUPP/search`,
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem("authToken")}`
            },
            data: finalData,
        })
            .then(function (res) {
                setLoader(false)
                setStoneData(res.data.data)
                setPageNumber(1)
                history.push({
                    pathname: `/${Cookies.get("view") || "search-result"}`,
                    state: {
                        searchresult: res.data.data,
                        oldvalues: location.state.oldvalues,
                        page: 1
                    },
                    // state: decompress(res.data.ProductDetails),
                });
                setTimeout(() => {
                    setLoader(false)
                }, 1000)
            })
            .
            catch(error => {
                if(error?.response?.data?.message === "UnAuthorized!"){
                    Logoutuser();
                }
            })
    }

    useEffect(() => {
        const getpagereload = sessionStorage.getItem("pageReloaded")
        if(getpagereload === "1"){
           if(!location.state.oldvalues){
            ReloadStockPage()
           }else{
            ReloadPage()
           }
            sessionStorage.setItem("pageReloaded","0")
        }
    },[])

    useEffect(() => {
        setStoneData(location.state.searchresult)
        if(!location.state.oldvalues){
            setStoneCount(location.state.searchresult.length)
            setDisableSorting(true)
        }
        else{
            setDisableSorting(false)
        }
    },[location.state])

    useEffect(() => {
        if(location.state.oldvalues){
        const fancy = Cookies.get("fancy")?1:0
        setCountLoader(true)
        let len = Object.keys(location.state.oldvalues).length;
        const temp = location.state.oldvalues;
        let data = "";
        for (let key in temp) {
            len--;
            let arr = temp[key];
            if (len) {
                if (Array.isArray(arr)) {
                    let str = "";
                    str += "'" + arr.join("','") + "'";
                    data += `{"FilterName": "${key}","FilterValue":"${str}" }, `;
                } else {
                    data += `{"FilterName": "${key}","FilterValue": "'${temp[key]}'"},`;
                }
            } else {
                if (Array.isArray(arr)) {
                    let str = "";
                    str += "'" + arr.join("','") + "'";
                    data += `{"FilterName": "${key}","FilterValue":"${str}" } `;
                } else {
                    data += `{"FilterName": "${key}","FilterValue": "'${temp[key]}'"}`;
                }
            }
        }
        let diamond_type = "N"
        if(userinfo.type !== "Natural"){
            diamond_type = "L"
        }
        const finalData = `{ "JsonData":  [${data}], "WLDiamondType": "${diamond_type}" ,"page":1,"fancy":"${fancy}" }`;
        // localStorage.setItem("modifysearch",JSON.stringify({...location.state.oldvalues}))
        axios({
            method: "POST",
            url: `${NODE_API_URL}/SUPP/search-count`,
            headers: {
                "Content-Type": "application/json",
                 "Authorization": `Bearer ${localStorage.getItem("authToken")}` 
            },
            data: finalData,
        })
        .then(function(rescount) {
            // setStoneCount(JSON.stringify(rescount.data.data));
            setCountLoader(false)
            setStoneCount(rescount.data.count)
        }).
        catch(error => {
          if(error?.response?.data?.message === "UnAuthorized!"){
            Logoutuser();
                      }
        })
        }
        else{
            setStoneCount(location.state.searchresult.length)
            setCountLoader(false)
        }
    },[updatecount])
    console.log("grid",detailView)

    const HandlePagination = (pageno) => {
        setInfiniteLoader(true)
        const fancy = Cookies.get("fancy")?1:0
        window.Nat = location.state.oldvalues;
        let len = Object.keys(location.state.oldvalues).length;
        const temp = location.state.oldvalues;
        let data = "";
        for (let key in temp) {
            len--;
            let arr = temp[key];
            if (len) {
                if (Array.isArray(arr)) {
                    let str = "";
                    str += "'" + arr.join("','") + "'";
                    data += `{"FilterName": "${key}","FilterValue":"${str}" }, `;
                } else {
                    data += `{"FilterName": "${key}","FilterValue": "'${temp[key]}'"},`;
                }
            } else {
                if (Array.isArray(arr)) {
                    let str = "";
                    str += "'" + arr.join("','") + "'";
                    data += `{"FilterName": "${key}","FilterValue":"${str}" } `;
                } else {
                    data += `{"FilterName": "${key}","FilterValue": "'${temp[key]}'"}`;
                }
            }
        }
        let diamond_type = "N"
        if(userinfo.type !== "Natural"){
            diamond_type = "L"
        }
        const finalData = `{ "JsonData":  [${data}], "WLDiamondType": "${diamond_type}" ,"page":${pageno},"fancy":"${fancy}","sortobj":${JSON.stringify(sortobj)} }`;
        axios({
            method: "POST",
            url: `${NODE_API_URL}/SUPP/search`,
            headers: {
                "Content-Type": "application/json",
                 "Authorization": `Bearer ${localStorage.getItem("authToken")}` 
            },
            data: finalData,
        })
        .then(function(res) {
            setInfiniteLoader(false)
            setStoneData([
                ...stoneData,
                ...res.data.data
            ])
        }).catch(error => {
            setInfiniteLoader(false)
          if(error?.response?.data?.message === "UnAuthorized!"){
            Logoutuser();
                      }
        })
    }
    
    useEffect(() => {
        if(stoneData.length !== parseFloat(stoneCount) && pagenumber !== 1){
            HandlePagination(pagenumber);
        }
    }, [pagenumber]);

    useEffect(() => {
        if(location.state.sortobj){
            setSortObj(location.state.sortobj)
        }
    },[])

    useEffect(() => {
        if(sortobj && sortobj.id){
            setLoader(true)
            const fancy = Cookies.get("fancy")?1:0
            window.Nat = location.state.oldvalues;
            let len = Object.keys(location.state.oldvalues).length;
            const temp = location.state.oldvalues;
            let data = "";
            for (let key in temp) {
                len--;
                let arr = temp[key];
                if (len) {
                    if (Array.isArray(arr)) {
                        let str = "";
                        str += "'" + arr.join("','") + "'";
                        data += `{"FilterName": "${key}","FilterValue":"${str}" }, `;
                    } else {
                        data += `{"FilterName": "${key}","FilterValue": "'${temp[key]}'"},`;
                    }
                } else {
                    if (Array.isArray(arr)) {
                        let str = "";
                        str += "'" + arr.join("','") + "'";
                        data += `{"FilterName": "${key}","FilterValue":"${str}" } `;
                    } else {
                        data += `{"FilterName": "${key}","FilterValue": "'${temp[key]}'"}`;
                    }
                }
            }
            let diamond_type = "N"
            if(userinfo.type !== "Natural"){
                diamond_type = "L"
            }
            const finalData = `{ "JsonData":  [${data}], "WLDiamondType": "${diamond_type}" ,"page":1,"fancy":"${fancy}","sortobj":${JSON.stringify(sortobj)} }`;
               
            axios({
                method: "POST",
                url: `${NODE_API_URL}/SUPP/search`,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem("authToken")}`
                },
                data: finalData,
            })
            .then(function (res) {
                setLoader(false)
                setStoneData(res.data.data)
                setPageNumber(1)
                history.push({
                    pathname: `/${Cookies.get("view") || "search-result"}`,
                    state: {
                        searchresult: res.data.data,
                        oldvalues: location.state.oldvalues,
                        page: 1
                    },
                    // state: decompress(res.data.ProductDetails),
                });
                setTimeout(() => {
                    setLoader(false)
                }, 1000)
            })
            .
            catch(error => {
                if(error?.response?.data?.message === "UnAuthorized!"){
                    Logoutuser();
                }
            })
        }
    },[sortobj])
    const onScroll = () => {
        const div = scrollRef.current;
        if (Math.round(div.scrollTop + div.clientHeight + 1) >= div.scrollHeight && stoneData.length > 0) {
            setPageNumber(prevPage => prevPage + 1);
        }
    };

    useEffect(() => {
        const div = scrollRef.current;
        if(div && !infiniteLoader){
            div.addEventListener('scroll', onScroll);
            return () => div.removeEventListener('scroll', onScroll);
        }
    }, [stoneData,scrollRef,infiniteLoader,detailView.length]);
    const removeStones =(selected)=>{
        if(selected.length === 0){
            alert("Please Select Diamonds")
            return
        }

        let temptotaldiamonds = 0
        let temptotalprice = 0
        let diamondcarat = 0
        diamondselected.map(value => {
            temptotaldiamonds += 1
            temptotalprice += parseFloat(value.supplierPrice)
            diamondcarat += parseFloat(value.carat)
            return {
                diamondcarat:diamondcarat,
                temptotalprice:temptotalprice,
                temptotaldiamonds:temptotaldiamonds,
            }
        })


        setTotalDiamonds(parseFloat(temptotaldiamonds))
        setTotalPrice(parseFloat(temptotalprice))
        setTotalCarat(parseFloat(diamondcarat))
        setTotalDollarCarat( temptotalprice !== 0 ?  parseFloat(temptotalprice) / parseFloat(diamondcarat) : "00")

        setShipStone(diamondselected)
        setRemoveStonePopup(true)
        console.log(shipStone)


    }

    const updateAvailibility =(selected)=>{
        console.log(selected)
        if(selected.length === 0){
            alert("Please Select Diamonds")
            return
        }

        let temptotaldiamonds = 0
        let temptotalprice = 0
        let diamondcarat = 0
        diamondselected.map(value => {
            temptotaldiamonds += 1
            temptotalprice += parseFloat(value.supplierPrice)
            diamondcarat += parseFloat(value.carat)
            return {
                diamondcarat:diamondcarat,
                temptotalprice:temptotalprice,
                temptotaldiamonds:temptotaldiamonds,
            }
        })


        setTotalDiamonds(parseFloat(temptotaldiamonds))
        setTotalPrice(parseFloat(temptotalprice))
        setTotalCarat(parseFloat(diamondcarat))
        setTotalDollarCarat( temptotalprice !== 0 ?  parseFloat(temptotalprice) / parseFloat(diamondcarat) : "00")
        setShipStone(diamondselected)
        setUpdateAvailibility(true)

    }

    const HandleRefreshPage = () => {
        if(!location.state.oldvalues){
            ReloadStockPage()
           }else{
            ReloadPage()
           }
      }


      useEffect(() => {
        const scrollToId = sessionStorage.getItem('scrollToId');
        if (detailView.length === 0 && scrollToId) {
          const element = document.getElementById(scrollToId);
          if (element) {
            setTimeout(() => {
              element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 100); // slight delay ensures DOM is rendered
          }
          sessionStorage.removeItem('scrollToId');
        }
      }, [detailView.length]);
      
    
  return (
    <> 
    {detailView.length !== 0 ? 
        <>
            <SearchDetail setDiamondSelected={setDiamondSelected} stoneData={detailView} setDetailView={setDetailView} userinfo={userinfo} updateAvailibility={updateAvailibility} removeStones={removeStones} />
        </>
    :
        <>
            {loader ? <SearchGridSkeleton/> : stoneData.length > 0 ?
                <div className='card card-custom card-sticky'>
                    <div className="card-header py-3 mb-3">
                        <div className="card-title">
                            {/* <button className="btn btn-sm btn-hover-transparent-primary mr-2" onClick={ ()=>history.goBack()}><IoChevronBackCircleOutline className="font-size-h5" /> Back</button> */}
                            <Link className="btn btn-sm btn-clear align-content-center d-flex btn-hover-transparent-primary font-size-h6 mr-2" to={{ pathname:'/search-diamond' }}><IoChevronBackCircleOutline className="font-size-h4 mr-1" /> Back</Link>
                            <span className="card-label font-weight-bold text-dark">
                                Search Result Grid {countloader?<span className="text-primary">Loading Count...</span>:<span className="text-primary">(Total stone: {stoneCount})</span>}
                            </span>
                        </div>
                        <div className="card-toolbar">
                            <button className="btn btn-primary btn-sm text-nowrap mr-2" onClick={()=>updateAvailibility(selected)}><span className="mr-1"><SVG  width="15" src={toAbsoluteUrl("/media/General/updateStatus.svg")} /></span>Update Status</button>
                            <OverlayTrigger placement="top" overlay={ <Tooltip id="tooltip"> Remove Stones </Tooltip> } >
                                <button className="btn btn-danger btn-icon btn-sm text-nowrap mr-2" onClick={()=>removeStones(selected)}><FaRegTrashAlt className="font-size-h5" /></button>
                            </OverlayTrigger>
                            {!isStockSearch?<Sorting sortobj={sortobj} setSortObj={setSortObj}/>:""}
                            <OverlayTrigger placement="top" overlay={ <Tooltip id="tooltip"> List view </Tooltip> } >
                                <button type="button" className="btn btn-light btn-icon btn-sm text-nowrap mr-2"  onClick={(e) => ChangeView()}><CiBoxList className='font-size-h5' /></button>
                            </OverlayTrigger>
                        </div>
                    </div>
                    <div className="card-body bg-white custom-scrollbar search-grid-card" ref={scrollRef}>
                        {successMsg ? 
                            <div className="mb-5 alert alert-custom alert-light-success alert-dismissible">
                                <div className="alert-text font-weight-bold">
                                    {successMsg}
                                </div>
                            </div>
                        : null }
                        <div className={`d-flex flex-wrap justify-content-${stoneData.length>3 ? "around" : "start"} gridData`}>
                            {stoneData.map((val,index) => {
                                const isItemSelected = isSelected(val.stockID);
                                const labelId = `enhanced-table-checkbox-${index}`;
                                return (
                                    <SearchGridComponent 
                                        stoneData={val}
                                        key={index}
                                        isItemSelected={isItemSelected}
                                        labelId={labelId}
                                        page={pagenumber}
                                        userinfo={userinfo}
                                        handleClick={handleClick}
                                        setDetailView={setDetailView}
                                        detailView={detailView}
                                        setDiamondSelected={setDiamondSelected}
                                    />
                                )
                            })}
                        </div>
                        {infiniteLoader?
                            <div className="card-body pt-5 pb-0">
                                <div className="d-flex flex-wrap justify-content-between gridData">
                                    {Array.from(Array(12), (e, i) => {
                                        return (
                                            <div className="mb-5 px-2" style={{width:"280px"}} key={i}>
                                                <div className="row m-0 card rounded-0">
                                                    <div className="col-12 p-0 d-flex align-items-center justify-content-center" >
                                                        <Skeleton variant="rect" height={220} width={280} />
                                                    </div>
                                                    <div className="col-12 mt-3 mb-1 d-flex justify-content-between align-items-center">
                                                        <Skeleton variant="text" width={60} />
                                                        <Skeleton variant="text" width={60} />
                                                        <Skeleton variant="text" width={20} />
                                                    </div>
                                                    <hr className="w-100 my-2" />
                                                    <div className="col-12 d-flex px-2 align-items-center">
                                                        <span className="mr-3"><Skeleton variant="circle" width={35} height={35} /></span>
                                                        <Skeleton variant="text" width={200} height={30}/>
                                                    </div>
                                                    <hr className="w-100 my-2" />
                                                    <div className="col-12 d-flex justify-content-between align-items-center">
                                                        <Skeleton variant="rect" width={100}  height={15}/>
                                                        <Skeleton variant="rect" width={100}  height={15}/>
                                                    </div>
                                                    <hr className="w-100 my-2" />
                                                    <div className="col-12 d-flex justify-content-between align-items-center">
                                                        <Skeleton variant="text" width={80} />
                                                        <Skeleton variant="text" width={40} />
                                                        <Skeleton variant="text" width={40} />
                                                        <Skeleton variant="text" width={20} />
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                        </div>:""}
                        {stoneData.length === parseFloat(stoneCount)?<div className="d-flex align-items-center justify-content-center">No more stones found</div>:""}
                    </div>
                </div>
            : 
            !infiniteLoader ?
                <div className="card custom-card">
                    <div className="card-body d-flex align-items-center  justify-content-center" style={{height:'70vh'}}>
                        <div className="text-center">
                            <img src={toAbsoluteUrl("/media/General/searchresult-no.png")} className="img-fluid" alt="searchresult-no"/>
                            <div className="mt-8 font-size-h4 text-capitalize text-primary"><strong>No Result Found</strong></div>
                            <div className="mt-3 text-muted">Please Modify Your Search</div>
                            <Link className="btn btn-primary px-8 mt-5" to={{ pathname:'/search-diamond' }}>Modify Search</Link>
                        </div>
                    </div>
                </div>
            :''
            }
        </>
    }
    <UpdateAvailibility setLoader={setLoader} setSuccessMsg={setSuccessMsg} show={updateAvailibilityPopup} onHide={() =>{ setUpdateAvailibility(false)}} data={shipStone} userinfo={userinfo} HandleRefreshPage={HandleRefreshPage}/>
    <ActiveShipping setLoader={setLoader} setSuccessMsg={setSuccessMsg} show={shipPopup} onHide={() => setShipPopup(false)} data={shipStone} userinfo={userinfo} HandleRefreshPage={HandleRefreshPage} totalDiamonds={totalDiamonds} totalPrice={totalPrice} totalDollarCarat={totalDollarCarat} totalCarat={totalCarat}/>
    <RemoveStones setLoader={setLoader} setSuccessMsg={setSuccessMsg} show={removeStonePopup} onHide={() => {setRemoveStonePopup(false)}} data={shipStone} userinfo={userinfo} HandleRefreshPage={HandleRefreshPage} totalDiamonds={totalDiamonds} totalPrice={totalPrice} totalDollarCarat={totalDollarCarat} totalCarat={totalCarat} setUpdateCount={setUpdateCount} updatecount={updatecount}/>
    </>
  )
}
